<template>
    <div>
        <v-alert
            type="error"
            class="mb-5"
            icon="mdi-alert-circle"
            variant="tonal"
            density="compact"
            style="font-size: 14px"
        >
            {{ $t('user_settings.delete_account.delete_account_message_1') }}
            <br />
            <b>{{ $t('user_settings.delete_account.delete_account_message_2') }}</b>
            <br />
            {{ $t('user_settings.delete_account.delete_account_message_3') }}
        </v-alert>

        <v-form ref="form" v-model="validDeleteForm" lazy-validation @submit.prevent="deleteUser">
            <p class="text-body-2 mb-1">Email</p>
            <v-text-field
                v-model="userMail"
                :rules="rules"
                :placeholder="currentUserEmail"
                type="text"
                required
                block
                density="compact"
                variant="outlined"
            ></v-text-field>

            <ButtonComponent
                type="submit"
                variant="error"
                prepend-icon="mdi-delete"
                :disabled="!validDeleteForm"
                :loading="loading"
            >
                {{ $t('user_settings.delete_account.delete_account_button') }}
            </ButtonComponent>
        </v-form>
    </div>
</template>

<script>
import { useUserStore } from '@/stores/user';
import { defaultErrorHandling } from '@/assets/js/utils';
import ButtonComponent from '@/components/utils/buttons/ButtonComponent.vue';
import { mainAxios as axios } from '@/assets/js/axios_config';

export default {
    name: 'DeleteUser',
    components: {
        ButtonComponent,
    },
    emits: ['close'],
    data: (vm) => ({
        user_store: useUserStore(),
        userMail: '',
        loading: false,
        validDeleteForm: false,
        rules: [
            (value) => !!value || 'Must be specified.',
            (value) => value === vm.currentUserEmail || 'Emails do not match.',
        ],
    }),
    computed: {
        currentUserEmail() {
            return this.user_store.get_user.email;
        },
    },
    methods: {
        async deleteUser() {
            this.$dialog.confirm({
                message: this.$t('user_settings.delete_account.delete_account_question'),
                onConfirm: async () => {
                    this.loading = true;
                    await axios
                        .delete('/users/')
                        .then(async () => {
                            this.loading = false;
                            this.$emit('close');
                            await this.user_store.logout(this.$t('alerts.success.account_deleted'));
                        })
                        .catch((error) => {
                            this.loading = false;
                            defaultErrorHandling(error);
                        });
                },
            });
        },
    },
};
</script>

<style></style>
